const fieldsModuleMapping = {
  accounts: {
    notes: 'AcctNote',
    id: 'AcctNo',
  },
};

export default fieldsModuleMapping;
